import './modules/detectCssSelectors'
import * as Sentry from '@sentry/browser'
import Vue from 'vue'
import Vuex from 'vuex'

import { globals, util, EventBus } from 'pevueglobal'

import VueProgressBar from 'vue-progressbar'
// import ScrollView from 'vue-scrollview'
import StorePE from './store.js'
import { router } from './router' // de router voor PE app
import * as components from './components'

import GlobalMixins from './modules/mixins/globalMixins'
import VeeValidate, { Validator } from 'vee-validate'
import CustomValidators from './modules/customvalidators/VeeValidate'
import { InitServerValidator } from './modules/customvalidators/servervalidators'
import localeFr from 'vee-validate/dist/locale/fr'
import localeNl from 'vee-validate/dist/locale/nl'
import localeDE from 'vee-validate/dist/locale/de'
import PortalVue from 'portal-vue'
import './modules/fontawesome/lib'
import './modules/gritter.js'
import { format } from 'date-fns'
import * as uiv from 'uiv'

if (util.GetCulture() === 'en-US') {
  PEGLOBALS.Xdateformat = 'MM-dd-yyyy'
} else if (util.GetCulture() === 'nl-NL' || util.GetCulture() === 'nl-BE') {
  PEGLOBALS.Xdateformat = 'dd-MM-yyyy'
} else if (util.GetCulture() === 'fr-BE' || util.GetCulture() === 'fr-FR') {
  PEGLOBALS.Xdateformat = 'dd/MM/yyyy'
} else {
  PEGLOBALS.Xdateformat = 'dd-MM-yyyy'
}

if (util.GetCulture() === 'en-US') {
  PEGLOBALS.XfnsFormat = 'M-d-YYYY'
} else if (util.GetCulture() === 'nl-NL' || util.GetCulture() === 'nl-BE') {
  PEGLOBALS.XfnsFormat = 'd-M-YYYY'
} else if (util.GetCulture() === 'fr-BE' || util.GetCulture() === 'fr-FR') {
  PEGLOBALS.XfnsFormat = 'd/M/YYYY'
} else {
  window.Xdateformat = 'd-m-yy'
}

// global function to close pdf iframe
window.closepdfiframe = function () {
  EventBus.$emit('closepdfiframe')
}

window.PEGLOBALS.EventBus = EventBus
// window.PEGLOBALS.EventBus.$emit('mailcheck') zo emit je een event
// eerst de error handling instellen
var hostname = window.location.hostname
var dsn = 'https://631d2bf49ae4cada763616d1c5debde0@o51706.ingest.us.sentry.io/4508356775641088'
if (hostname === 'www.pe-online.org') {
  Sentry.init({ dsn, environment: 'Production' })
  util.GoogleAnalytics('UA-7389062-1') // Set google analytics, live server
} else if (hostname === 'staging.pe-online.org') {
  Sentry.init({ dsn, environment: 'Staging' })
} else if (hostname === 'acc.pe-online.org') {
  Sentry.init({ dsn, environment: 'Acceptance' })
  util.GoogleAnalytics('UA-7389062-4') // Set google analytics, acceptance server
} else if (hostname === 'knblive.pe-online.org') {
  Sentry.init({ dsn, environment: 'KnbLive' })
} else {
  Sentry.init({ dsn: '', enabled: false })
}

// wacht totdat html geladen is
document.addEventListener('DOMContentLoaded', function (event) {
  $('#splashholder2').hide() // windmolen kan uit alles geladen

  // wrap de initialisatie in raven wrapper
  Sentry.configureScope((scope) => {
    scope.setTag('logger', 'vueJS')

    window.peenv = 'development'
    globals.router = router
    Vue.mixin(GlobalMixins)

    Vue.filter('format2decimal', function (value) {
      if (value === undefined || value === null) return ''
      return value.toLocaleString(util.GetCulture())
    })
    Vue.config.performance = true
    // init vuex for store
    Vue.use(Vuex)
    var store = StorePE()

    // init progressbar

    const pboptions = {
      color: store.state.colors.primary,
      failedColor: store.state.colors.danger,
      thickness: '2px',
      transition: {
        speed: '0.2s',
        opacity: '0.6s',
        termination: 300,
      },
      autoRevert: true,
      location: 'top',
      inverse: false,
    }

    Vue.filter('formatDate', function (value) {
      if (!value) return ''
      if (value instanceof Date) {
        return format(value, PEGLOBALS.Xdateformat)
      } else {
        return value
      }
    })

    // Vue.use(ScrollView, options)  // documentatie https://chrishurlburt.gitbooks.io/vue-scrollview/content/setup/plugin-options.html
    Vue.use(VueProgressBar, pboptions)

    Vue.use(PortalVue)
    Validator.localize('fr', localeFr)
    Validator.localize('nl', localeNl)
    Validator.localize('de', localeDE)

    Validator.localize(util.GetCulture().split('-')[0])
    for (let val in CustomValidators) {
      Validator.extend(val, CustomValidators[val])
    }
    // init server validators
    InitServerValidator()

    const veeValidateConfig = {
      fieldsBagName: 'fieldBags',
    }
  
    Vue.use(VeeValidate, veeValidateConfig)
    //  preload date for vue appliciation
    // modal window
    Vue.use(uiv)
    globals.init(components, Vue)

    // de in .net gedefinieerde html elementen die een vue app moeten worden (zoals de contentwrapper en xvqanda) met jquery ophalen
    var apparray = $('[data-xauvueapp]')

    // de html elementen opwaarderen naar een vue component
    apparray.each((index) => {
      var idvueapp = $(apparray[index]).attr('id')
      void new Vue({
        el: '#' + idvueapp,
        store,
        router,
      })
    })
  })

  util.CheckTokenAsync()
})
